export type LanguageOption = {
  value: string;
  code: string;
  locale: string;
  dir: "ltr" | "rtl";
};

const LANGUAGE_DATA = [
  ["English", "EN", "en", "ltr"],
  ["Luganda", "LG", "lg", "ltr"],
  ["Kiswahili", "SW", "sw", "ltr"],
  ["Swahili", "SW", "sw", "ltr"],
  ["French", "FR", "fr", "ltr"],
  ["Arabic", "AR", "ar", "rtl"],
  ["Portuguese", "PT", "pt", "ltr"],
  ["Spanish", "ES", "es", "ltr"],
  ["German", "DE", "de", "ltr"],
  ["Italian", "IT", "it", "ltr"],
  ["Dutch", "NL", "nl", "ltr"],
  ["Danish", "DA", "da", "ltr"],
  ["Norwegian", "NO", "no", "ltr"],
  ["Swedish", "SV", "sv", "ltr"],
  ["Finnish", "FI", "fi", "ltr"],
  ["Icelandic", "IS", "is", "ltr"],
  ["Polish", "PL", "pl", "ltr"],
  ["Czech", "CS", "cs", "ltr"],
  ["Slovak", "SK", "sk", "ltr"],
  ["Hungarian", "HU", "hu", "ltr"],
  ["Romanian", "RO", "ro", "ltr"],
  ["Bulgarian", "BG", "bg", "ltr"],
  ["Greek", "EL", "el", "ltr"],
  ["Ukrainian", "UK", "uk", "ltr"],
  ["Russian", "RU", "ru", "ltr"],
  ["Turkish", "TR", "tr", "ltr"],
  ["Hebrew", "HE", "he", "rtl"],
  ["Persian", "FA", "fa", "rtl"],
  ["Urdu", "UR", "ur", "rtl"],
  ["Hindi", "HI", "hi", "ltr"],
  ["Bengali", "BN", "bn", "ltr"],
  ["Tamil", "TA", "ta", "ltr"],
  ["Telugu", "TE", "te", "ltr"],
  ["Marathi", "MR", "mr", "ltr"],
  ["Gujarati", "GU", "gu", "ltr"],
  ["Punjabi", "PA", "pa", "ltr"],
  ["Nepali", "NE", "ne", "ltr"],
  ["Sinhala", "SI", "si", "ltr"],
  ["Thai", "TH", "th", "ltr"],
  ["Vietnamese", "VI", "vi", "ltr"],
  ["Indonesian", "ID", "id", "ltr"],
  ["Malay", "MS", "ms", "ltr"],
  ["Filipino", "FIL", "fil", "ltr"],
  ["Chinese (Simplified)", "ZH", "zh-CN", "ltr"],
  ["Chinese (Traditional)", "ZH", "zh-TW", "ltr"],
  ["Mandarin", "ZH", "zh", "ltr"],
  ["Japanese", "JA", "ja", "ltr"],
  ["Korean", "KO", "ko", "ltr"],
  ["Mongolian", "MN", "mn", "ltr"],
  ["Amharic", "AM", "am", "ltr"],
  ["Kinyarwanda", "RW", "rw", "ltr"],
  ["Kirundi", "RN", "rn", "ltr"],
  ["Somali", "SO", "so", "ltr"],
  ["Oromo", "OM", "om", "ltr"],
  ["Hausa", "HA", "ha", "ltr"],
  ["Yoruba", "YO", "yo", "ltr"],
  ["Igbo", "IG", "ig", "ltr"],
  ["Zulu", "ZU", "zu", "ltr"],
  ["Xhosa", "XH", "xh", "ltr"],
  ["Afrikaans", "AF", "af", "ltr"],
  ["Sesotho", "ST", "st", "ltr"],
  ["Setswana", "TN", "tn", "ltr"],
  ["Chichewa", "NY", "ny", "ltr"],
  ["Shona", "SN", "sn", "ltr"],
  ["Lingala", "LN", "ln", "ltr"],
  ["Wolof", "WO", "wo", "ltr"],
  ["Malagasy", "MG", "mg", "ltr"],
  ["Haitian Creole", "HT", "ht", "ltr"],
  ["Māori", "MI", "mi", "ltr"],
  ["Samoan", "SM", "sm", "ltr"],
  ["Tongan", "TO", "to", "ltr"],
  ["Fijian", "FJ", "fj", "ltr"],
  ["Latin", "LA", "la", "ltr"],
  ["Esperanto", "EO", "eo", "ltr"],
  ["Sign language interpretation", "SIGN", "zxx", "ltr"],
] as const;

export const LANGUAGE_OPTIONS: LanguageOption[] = LANGUAGE_DATA.map(([value, code, locale, dir]) => ({
  value,
  code,
  locale,
  dir,
}));

export const LANGUAGE_NAMES = LANGUAGE_OPTIONS.map(language => language.value);
